import React from 'react';

import { Typography, makeStyles } from '@material-ui/core';

import Facilities from '../../components/techQASettings/Facilities';

const useStyles = makeStyles((theme) => ({
  header: {
    alignItems: 'right',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
  },
  pageTitle: {
    color: '#172B4D',
    fontSize: '24px',
    fontWeight: 'bold',
  },
  root: {
    padding: '20px 70px',
  },
}));

const TechQASettings = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography className={classes.pageTitle}>Tech QA Settings</Typography>
      </div>

      <Facilities />
    </div>
  );
};

export default TechQASettings;
